import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
} from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule, MatRowDef, MatTableDataSource } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import BusinessPartnerAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity";
import {
  BusinessPartnerScheduleAttributes,
  CompanyAttributes,
  CurrencyAttributes,
  MaterialAttributes,
  ScheduleTypeEnum,
} from "@albatrosdeveloper/ave-models-package";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MaterialPriceListService } from "app/modules/components/master/strategy-list/strategy-price-list.service";
import MaterialPriceListAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-price-list/material-price-list.entity";
import { getCode } from "app/utils/method";
import SalesOrganizationAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-organization/sales-organization.entity";
import PriceListAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/price-list/price-list.entity";
import { debounceTime, distinctUntilChanged, Subject } from "rxjs";
import { environment } from "environments/environment.prod";
import { SalesOrganizationService } from "app/modules/components/configuration/sales-organization/sales-organization.component.service";
import { PriceListService } from "app/modules/components/master/price-list/price-list.service";
import { MaterialService } from "app/modules/components/material/material/material.service";
import { IRequestResult } from "app/common/interfaces";
import AlternalUnitMeasurementAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material/alternal-unit-measure/alternal-unit-measure.entity";
import { buildQuery, Ops, where } from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { CompanyService } from "app/modules/components/configuration/company/company.service.service";
import { TablePriceListComponent } from "app/modules/components/master/strategy-list/table-price-list/table-price-list.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { ConditionClassEnum } from "app/modules/components/master/strategy-list/condition-class-enum";

@Component({
  selector: "app-form-price-list-modal",
  templateUrl: "./form-price-list-modal.component.html",
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatIconModule,
    FormsModule,
    NgxMatSelectSearchModule,
    MatDatepickerModule,
    TablePriceListComponent
  ],
})
export class FormPriceListModalComponent implements OnInit {
  currentPriceList: any = this.initializePriceList(); //TODO
  public id: any = null

  //filter
  salesOrganizationList: SalesOrganizationAttributes[] = [];

  priceList: PriceListAttributes[] = [];
  listFilterPriceList: PriceListAttributes[] = []
  searchPriceList = ''

  materialList: MaterialAttributes[] = [];
  searchMaterial = ''
  private searchSubject = new Subject<string>();
  
  unitMeasureList: AlternalUnitMeasurementAttributes[] = []

  rangeList: {code: string; name: string}[] = [
    {code: '0-6', name: '0-6'},
    {code: '6-12', name: '6-12'},
    {code: '12-18', name: '12-18'}
  ]

  listFilterCurrency: CurrencyAttributes[] = []

  rangePriceList = new FormGroup({
    start: new FormControl(null, Validators.required),
    end: new FormControl(null, Validators.required)
  });

  constructor(
    private materialPriceListService: MaterialPriceListService,
    private readonly salesOrganizationService: SalesOrganizationService,
    private readonly priceListService: PriceListService,
    private readonly materialService: MaterialService,
    private readonly companyService: CompanyService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.getAllSalesOrganization()
    this.setupMaterialSearchControl()
    this.getMaterialList()
    this.getCurrency()
    this.initForm()
  }

  initializePriceList() {
    return {
      distributionChainId: "",
      priceListId: "",
      rangeId: "",
      itemId: "",
      unitMeasureId: "",
      currencyId: "",
      // dateStart:null, dateEnd:null, 
      price: null, 
      scalePrices: []
    }
  }

  initForm(){
    if(this.data && this.data.materialPriceList){
      this.currentPriceList = {
        ...this.data.materialPriceList,
        distributionChainId: this.data.materialPriceList.field1,
        itemId: this.data.materialPriceList.field6,
        unitMeasureId: this.data.materialPriceList.field7,
        currencyId: this.data.materialPriceList.field5,
        rangeId: this.data.materialPriceList.field8
      };
      if(this.data.materialPriceList.dateStart && this.data.materialPriceList.dateEnd){
        this.rangePriceList.setValue({
          start: this.data.materialPriceList.dateStart,
          end: this.data.materialPriceList.dateEnd
        });
      }
      this.id = this.data.materialPriceList._id
    }else{
      this.currentPriceList = this.initializePriceList();
      this.id = null
    }
  }

  onSubmit(){
    const priceList: MaterialPriceListAttributes = {
      conditionClass: ConditionClassEnum.XP01,
      sequence: 'S0',
      field1: this.currentPriceList.distributionChainId || null, // org venta
      field2: null, //
      field3: this.data.businessPartner._id, //BP
      field4: null, // precio lista
      field5: this.currentPriceList.currencyId || null, // currency
      field6: this.currentPriceList.itemId || null, // id material
      field7: this.currentPriceList.unitMeasureId || "", // unidad de medida
      field8: this.currentPriceList.rangeId || null, // range
      field9: null,
      field10: null,
      field11: null,
      field12: null,
      field13: null,
      dateStart: this.rangePriceList.value.start ? new Date(this.rangePriceList.value.start).toISOString().split('T')[0] : null,
      dateEnd: this.rangePriceList.value.end ? new Date(this.rangePriceList.value.end).toISOString().split('T')[0] : null,

      price: this.currentPriceList.price, // price
      minimumPrice: 0,
      maximumPrice: 0,
      hasScalePrices: this.currentPriceList.scalePrices && this.currentPriceList.scalePrices.length > 0 ? true : false,
      hasMinimumAndMaximunPrices: false,
      scalePrices: this.currentPriceList.scalePrices && this.currentPriceList.scalePrices.length > 0 ? this.currentPriceList.scalePrices : []
    };
  
    if(priceList.field1 == null || priceList.field6 == null){
      return;
    }

    if(this.id == null){
      this.createPriceList(priceList)
    }else{
      this.updatePriceList(this.id, priceList)
    }
  }

  createPriceList(priceList){
    this.materialPriceListService.create(priceList).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updatePriceList(id: string,priceList): void {
    this.materialPriceListService.update(id, priceList).subscribe({
      next: () => {
        this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  //filter
  private getAllSalesOrganization(): void {
    this.salesOrganizationService.findToComboBox().subscribe({
      next: (res) => {
        this.salesOrganizationList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener organizaciónes de ventas.","Cerrar",{ duration: 5000});
      },
    });
  }


  private getPriceList(): void {//Verificar si se esta utilizando
    this.priceListService.findToComboBoxPriceList('P').subscribe({
      next: (res: IRequestResult<PriceListAttributes[]>) => {
        this.priceList = res.data;
        this.listFilterPriceList = this.priceList.slice()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener listas de precios.","Cerrar",{ duration: 5000});
      },
    });
  }

  changueOptionsPriceList(event) {
    if (!this.priceList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterPriceList = this.priceList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterPriceList = this.priceList.filter(item => item.name.toLowerCase().indexOf(search) > -1 || item.code.toLowerCase().indexOf(search) > -1)
  }

  private getMaterialList(): void {
    const materialOptions = {
      search: this.searchMaterial ? this.searchMaterial : null,
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
      //sortDirection: "ASC"
    };

    const companyCodes = [environment.companyId];
    //const salesOfficeSelected = this.salesOfficesList.find(so => so._id.toString() == this.salesOfficeControl.value)

    this.materialService.findAllComboWithCount(
      materialOptions,
      companyCodes,
      this.data.materialPriceList ? this.data.materialPriceList.field6 : this.currentPriceList.itemId || null
    ).subscribe({
      next: (res: IRequestResult<MaterialAttributes[]>) => {
        this.materialList = res?.data ?? [];
        //this.currentPriceList.itemId = this.data && this.data.materialPriceList ? this.data.materialPriceList.field6  : ""
        this.getUnitMeasureList()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener materiales.","Cerrar",{ duration: 5000});
      },
    })
  }

  changueOptionsMaterial(event) {
    this.searchSubject.next(event);
  }

  private setupMaterialSearchControl(): void {
    this.searchSubject
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((searchTerm) => {
        if (searchTerm) {
          this.searchMaterial = searchTerm;
          this.getMaterialList();
        }
      });
  }

  getUnitMeasureList(){
    const selectedItem = this.materialList.find(item => item._id === this.currentPriceList.itemId);

    if(selectedItem){
      if(selectedItem.alternalUnitOfMeasures && selectedItem.alternalUnitOfMeasures.length >= 0){
        const baseUnitFound = selectedItem.alternalUnitOfMeasures.some(um => um.unitOfMeasure._id === selectedItem.baseUnitOfMeasure._id);
  
        // Si no está, agregar baseUnitOfMeasure al inicio
        if (!baseUnitFound) {
          selectedItem.alternalUnitOfMeasures.unshift({
            isUMB: true,
            isUMP: false,
            quantity: 1,
            equivalentQuantity: 1,
            conversionFactor: 1,
            barcode: "",
            price: null,
            unitOfMeasure: {
              _id: selectedItem.baseUnitOfMeasure._id,
              code: selectedItem.baseUnitOfMeasure.code,
              name: selectedItem.baseUnitOfMeasure.name,
              statusId: selectedItem.baseUnitOfMeasure.statusId,
              //_deleted: false
            }
          });
        }
      }else if(selectedItem.baseUnitOfMeasure){
        selectedItem.alternalUnitOfMeasures.unshift({
          isUMB: true,
          isUMP: false,
          quantity: 1,
          equivalentQuantity: 1,
          conversionFactor: 1,
          barcode: "",
          price: null,
          unitOfMeasure: {
            _id: selectedItem.baseUnitOfMeasure._id,
            code: selectedItem.baseUnitOfMeasure.code,
            name: selectedItem.baseUnitOfMeasure.name,
            statusId: selectedItem.baseUnitOfMeasure.statusId,
          }
        });
      }
  
      this.unitMeasureList = selectedItem.alternalUnitOfMeasures
    }
  }

  getCurrency(){
    const query = buildQuery<CompanyAttributes>(
      where("id", Ops.eq(environment.companyId)),
    )

    this.companyService.fetchCompany(query).subscribe({
      next: (res: IRequestResult<CompanyAttributes[]>) => {
        let company = res.data && res.data.length > 0 ? res.data[0]: null;
        if(company && company.currencyBase){
          this.listFilterCurrency = [company.currencyBase]
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener moneda.","Cerrar",{ duration: 5000});
      },
    });
  }
}